import React from 'react';
import { useFlowComponent } from '@/hooks/useFlowComponent';

export const withFlowComponent =
  (MobileComponent, DesktopComponent) => (props) => {
    const Component = useFlowComponent(MobileComponent, DesktopComponent);

    return <Component {...props} />;
  };
